
export default {
  name: 'TutorialTitle',

  props: {
    data: {
      type: Object,
      default: () => ({
        title: '[This is the Title]',
        textAlign: 'center',
      }),
    },
  },

  data() {
    return {
      title: this.data?.title,
      textAlign: this.data.textAlign,
    }
  },
}
